export default class _State extends Phaser.State {
  constructor (stateProvider) {
    super();
    this.stateProvider = stateProvider;
  }
}



/** WEBPACK FOOTER **
 ** ./scripts/states/_State.js
 **/